export default "__VITE_ASSET__Ce5KIsOO__"